import { styled } from '@mui/material/styles';
import { Typography, Divider } from '@mui/material';
import { PropsWithChildren } from 'react';

export const SocialButtonsContainer = styled('div', { name: 'SocialButtonsContainer' })(
	({ theme }) => ({
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(3),
		alignItems: 'center',
		marginTop: theme.spacing(8),
	})
);

export const FormBox = styled('form', { name: 'FormBox' })(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(4),
}));

export const FormBlock = styled('div', { name: 'FormBlock' })({});

export function LoginDivider({ children }: PropsWithChildren) {
	return (
		<Divider sx={{ my: 6 }}>
			<Typography component="span" color="secondary">
				{children}
			</Typography>
		</Divider>
	);
}
